module.exports = __webpack_public_path__ + "static/media/wen_yi_huang.1babad24.jpg";